import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "impx-menu-carousel",
  class: "impx-menu-carousel uk-padding uk-position-relative uk-padding-remove-horizontal mobile-rmv-pad vert uk-background-fixed uk-background-center-center uk-height-1-1"
}
const _hoisted_2 = { class: "uk-container uk-container-large" }
const _hoisted_3 = { class: "uk-grid uk-light" }
const _hoisted_4 = { class: "uk-width-xlarge-2-3 uk-width-large-2-3 uk-width-medium-3-4 uk-width-xlarge-1-1 uk-container-center impx-margin-top" }
const _hoisted_5 = { class: "impx-intro intro-light uk-text-center uk-contrast uk-position-relative uk-position-z-index" }
const _hoisted_6 = { class: "uk-margin-remove" }
const _hoisted_7 = { class: "uk-grid uk-flex uk-flex-center" }
const _hoisted_8 = { class: "uk-width-1-1" }

import MenuCard from "@/views/restaurant/components/MenuCard.vue";
import MenuBlocItem from "@/views/restaurant/components/MenuBlocItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RestaurantMenu',
  props: {
      menuList:[],
      menuTitle:String,
    },
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "impx-overlay dark" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(props.menuTitle??''), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(MenuCard, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menuList, (menu, index) => {
                return (_openBlock(), _createBlock(MenuBlocItem, {
                  key: index,
                  title: menu?.title,
                  desc: menu?.subtitle,
                  "img-desc": menu?.menuImage?.url,
                  "menu-list": menu.menus??[]
                }, null, 8, ["title", "desc", "img-desc", "menu-list"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})